module.exports = __webpack_public_path__ + "static/media/Ellipse 4.aefbd7cd.png";